var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import fetch from 'node-fetch';
import requestIp from 'request-ip';
function getUserData(req) {
    var _a, _b;
    return {
        client_ip_address: requestIp.getClientIp(req),
        client_user_agent: req.headers['user-agent'],
        fbc: ((_a = req.cookies) === null || _a === void 0 ? void 0 : _a._fbc) || '',
        fbp: ((_b = req.cookies) === null || _b === void 0 ? void 0 : _b._fbp) || ''
    };
}
function createTrackFacebookEvent({ pixelID, token }) {
    return function trackFacebookEvent(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`https://graph.facebook.com/v11.0/${pixelID}/events?access_token=${token}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    data: [data]
                })
            });
            return response;
        });
    };
}
export default function createFacebookTracker(config) {
    const trackFacebookEvent = createTrackFacebookEvent(config);
    const track = (event, data, request) => __awaiter(this, void 0, void 0, function* () {
        const user_data = getUserData(request);
        const event_time = Math.floor(Date.now() / 1000);
        const defaults = {
            user_data,
            event_time,
            action_source: 'website',
            event_source_url: data.location,
            event_id: data.eventId
        };
        switch (event) {
            case 'trackProduct':
                const productData = data.props;
                if (productData.action === 'add') {
                    return yield trackFacebookEvent(Object.assign(Object.assign({}, defaults), { event_name: 'AddToCart', custom_data: {
                            contents: [
                                {
                                    id: productData.product.id.toString(),
                                    quantity: productData.quantity,
                                    item_price: productData.product.price.incVat
                                }
                            ],
                            content_name: productData.product.name,
                            content_type: 'product',
                            currency: data.currency,
                            value: productData.product.price.incVat
                        } }));
                }
                else if (productData.action === 'view') {
                    return yield trackFacebookEvent(Object.assign(Object.assign({}, defaults), { event_name: 'ViewContent', custom_data: {
                            contents: [
                                {
                                    id: productData.product.id.toString(),
                                    quantity: productData.quantity,
                                    item_price: productData.product.price.incVat
                                }
                            ],
                            content_name: productData.product.name,
                            content_type: 'product',
                            currency: data.currency,
                            value: productData.product.price.incVat
                        } }));
                }
            case 'trackAddToWishList':
                const wishListData = data.props;
                return yield trackFacebookEvent(Object.assign(Object.assign({}, defaults), { event_name: 'AddToWishlist', custom_data: {
                        content_name: wishListData.productName,
                        content_category: data.context.list || '',
                        content_ids: [wishListData.articleNumber],
                        currency: data.currency
                    } }));
            case 'trackRegister':
                return yield trackFacebookEvent(Object.assign(Object.assign({}, defaults), { event_name: 'CompleteRegistration', custom_data: {} }));
            case 'trackCartCheckout':
                const checkoutData = data.props;
                return yield trackFacebookEvent(Object.assign(Object.assign({}, defaults), { event_name: 'InitiateCheckout', custom_data: {
                        content_ids: checkoutData.cart.items.map(item => item.articleNumber),
                        contents: checkoutData.cart.items.map(item => {
                            return {
                                id: item.articleNumber,
                                quantity: item.quantity,
                                item_price: item.product.price.incVat
                            };
                        }),
                        currency: data.currency,
                        num_items: checkoutData.cart.totalQuantity,
                        value: checkoutData.cart.productTotal.incVat
                    } }));
            case 'trackPageView':
                const pageViewData = data.props;
                return yield trackFacebookEvent(Object.assign(Object.assign({}, defaults), { event_name: 'PageView', custom_data: {
                        content_name: pageViewData.title,
                        currency: data.currency
                    } }));
        }
    });
    return track;
}
//# sourceMappingURL=facebook.js.map